// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoLight_630683', '__robotoLight_Fallback_630683'","fontWeight":300},"className":"__className_630683","variable":"__variable_630683"};